/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { useResponsiveMode } from 'src/core/hooks/useResponsiveMode';

/**
 * Divides the items into original items and overflow items based on
 * the current responsive mode of the screen.
 */
export const useOverflowedItems = <T extends object>(items: T[]): { items: T[]; overFlowItems: T[] } => {
    const { isSmallOrGreater, isLargeOrGreater, isMediumOrGreater, isXLargeOrGreater } = useResponsiveMode();
    const totalSize = items.length;

    if (isXLargeOrGreater) {
        return { items, overFlowItems: [] };
    }
    if (isLargeOrGreater) {
        return {
            items: items.slice(0, totalSize / 2),
            overFlowItems: items.slice(totalSize / 2)
        };
    }
    if (isMediumOrGreater) {
        return {
            items: items.slice(0, totalSize / 4),
            overFlowItems: items.slice(totalSize / 4)
        };
    }
    if (isSmallOrGreater) {
        return { items: [], overFlowItems: items.slice() };
    }
    return { items: [], overFlowItems: items.slice() };
};
